/* eslint-disable */
import { LoginConfig } from '@/common/config';

import { getUserInfoData } from './commonInfo';
import { checkBridge, runBridge } from './jsBridgeUtils';

// H5页登录
export const initLogin = () => {
  const h5LoginSdk = (window as any).login;
  const query = queryURLParams(window.location.href);
  const loginConfig = LoginConfig[query?.location_country || 'MX'];
  h5LoginSdk && h5LoginSdk.setConfig(loginConfig);
};

export const openNewPage = (url: string, params?: { [key: string]: any }) => {
  const globalWindow = window as any;
  const module = globalWindow?.Fusion?.loadModule('newPageModule');
  if (module.openNewPage) {
    module.openNewPage({
      url,
      ...params
    });
  } else {
    window.location.href = url;
  }
};

export const queryURLParams = (url: string) => {
  // url上取参数
  const result: any = {};
  const reg1 = /([^?=&#]+)=([^?&#]*)/g;
  const reg2 = /\%24/;
  const reg3 = /\%22/;
  const reg4 = /\%2C/;
  // reg1 = /([^?=&#]+)=([^?=&#]+)/g 老的正则
  // reg2 = /#([^?=&#]+)/g;
  url = url.replace(reg2, '$');
  url = url.replace(reg3, '"');
  url = url.replace(reg4, ',');
  url.replace(reg1, (n, x, y) => (result[x] = y));

  // url.replace(reg2, (n, x) => result['HASH'] = x);
  return result;
};

export const getPosition = new Promise((resolve, reject) => {
  const locationInfo = { lng: 0, lat: 0 };
  if (checkBridge('getLocationInfo')) {
    runBridge('getLocationInfo', {}, (loc: any) => {
      locationInfo.lng = loc?.lng || locationInfo?.lng;
      locationInfo.lat = loc?.lat || locationInfo?.lat;
      resolve(locationInfo);
    });
  } else {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (loc: any) => {
          // 获取地理位置成功
          locationInfo.lng = loc.coords.longitude || locationInfo?.lng;
          locationInfo.lat = loc.coords.latitude || locationInfo?.lat;
          resolve(locationInfo);
        },
        function (error) {
          // 取地理位置失败
          console.log('no');
          console.log(error); //错误信息
          // 因为是从谷歌返回的数据,国家政策的原因,无法获取(需要翻墙)
          // Network location provider at 'https://www.googleapis.com/' : No response received
          reject();
        },
        {
          // 2000ms
          timeout: 2000
        }
      );
    }
    resolve(locationInfo);
  }
});

export const commonParams = () => {
  const query = queryURLParams(window.location.href);
  // const locationInfo: any = await getPosition
  const ticket = getUserInfoData()?.ticket;
  return {
    location_country: query?.location_country || '',
    ticket: ticket || query?.ticket || '',
    lang: LoginConfig[query?.location_country]?.lang,
    // H5 检测参数中是否存在经纬度
    lng: query?.lng,
    lat: query?.lat
  };
};

export const random = (upper: number, lower: number) => {
  return Math.floor(Math.random() * (upper - lower)) + lower;
};

export const callHelpPhone = (tel: string) => {
  window.location.href = `tel:${tel}`;
};

export const CreateUrl = ({ url = '', queryObj = {}, hash = '' }) => {
  const queryObjs: any = queryObj;
  if (!url) return;
  const queryTag = url.indexOf('?');
  const hashTag = url.indexOf('#');
  const queryObjKeys = Object.keys(queryObjs);
  const arr = url.split('#');
  let result = '';
  let appendQueryString = '';
  let posTag = '?';
  let hashName = hashTag === -1 ? '' : `#${arr[1]}`;
  if (queryObjKeys.length) {
    queryObjKeys.map(i => {
      queryObjs[i] != null && (appendQueryString += `${i}=${queryObjs[i]}&`);
    });
    appendQueryString = appendQueryString.replace(/&$/, '');
  }
  queryTag > -1 && (posTag = '&');
  if (queryTag === -1 && !appendQueryString) {
    posTag = '';
  }
  hash && (hashName = `#${hash}`);
  result = `${arr[0]}${posTag}${appendQueryString}${hashName}`;
  return result;
};

export const base64toFile = (dataurl: string, filename = 'file') => {
  let arr = dataurl.split(',');
  let mime = (arr[0] as any).match(/:(.*?);/)[1];
  let suffix = mime.split('/')[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  });
};

export const imageSize = (base64Str: string) => {
  const indexBase64 = base64Str.indexOf('base64,');
  if (indexBase64 < 0) return -1;
  const str = base64Str.substr(indexBase64 + 6);
  return (str.length * 0.75).toFixed(2);
};

export const getGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const debounce = (callback = () => {}, wait = 300, immediate = false) => {
  // 防抖
  let timeout: any = null;
  return function () {
    const context = this;
    const args: any = arguments;
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 判断是否执行过
      const flag = !timeout;
      timeout = setTimeout(() => {
        callback.apply(context, args);
      }, wait);
      if (flag) callback.apply(context, args);
    } else {
      timeout = setTimeout(() => {
        callback.apply(context, args);
      }, wait);
    }
  };
};

/**
 * 从端bridge获取登录信息
 * @returns
 */
export const getUserInfo = async (): Promise<
  { uid: string; ticket: string; phone: string } | undefined
> =>
  new Promise(resolve => {
    // 设置500ms超时
    const timeout = setTimeout(() => {
      resolve(undefined);
    }, 500);

    const globalWindow = window as any;
    const fusion = globalWindow?.Fusion;

    if (fusion && typeof fusion.getUserInfo === 'function') {
      fusion.getUserInfo({}, (userInfo: { uid: string; ticket: string; phone: string }) => {
        clearTimeout(timeout);
        resolve(userInfo);
      });
    } else {
      // 如果 Fusion 不可用，直接返回 undefined
      clearTimeout(timeout);
      resolve(undefined);
    }
  });
